import { render, staticRenderFns } from "./ImportCsvModal.vue?vue&type=template&id=024b4b8c&"
import script from "./ImportCsvModal.vue?vue&type=script&lang=js&"
export * from "./ImportCsvModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports